import React from 'react'
import './chart.css'
import {
    BarChart,
    Bar,
    XAxis, YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,

} from 'recharts'
const Chart = ({ data }) => {
    return (
        <>
            <div className="chart">
                <ResponsiveContainer
                    width="100%"
                >
                    <BarChart
                        data={data}
                        width={500}
                        height={300}
                        margin={{
                            top: 5,
                            right: 20,
                            left: 30,
                            bottom: 5
                        }}
                    >
                        <CartesianGrid strokeDasharray='3 3'>

                        </CartesianGrid>
                        <XAxis dataKey="country">
                        </XAxis>
                        <YAxis dataKey="cases"></YAxis>
                        <Tooltip></Tooltip>
                        <Legend />
                        <Bar dataKey="country" fill='#888fab'></Bar>
                        <Bar dataKey="cases" fill='#82ca9d'></Bar>
                        <Bar dataKey="recovered" fill='#888fab'></Bar>
                        <Bar dataKey="deathes" fill='#82ca9d'></Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </>
    )
}

export default Chart